import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { Public, MoneyOff, Schedule, Usb, WarningAmber } from '@mui/icons-material';
import '../styles/styles.css';

const features = [
  {
    icon: <Usb sx={{ fontSize: 22, color: '#6C63FF' }} />,
    title: 'A public flash drive',
    description: 'Storify works like a USB stick that lives on the web. Plug in from any device, drop your files, and pick them up anywhere else.',
  },
  {
    icon: <Public sx={{ fontSize: 22, color: '#6C63FF' }} />,
    title: 'Open to everyone',
    description: 'No accounts, no logins, no setup. Anyone can upload and download files instantly, which also means every file is publicly visible.',
  },
  {
    icon: <MoneyOff sx={{ fontSize: 22, color: '#6C63FF' }} />,
    title: 'Free to use',
    description: 'Completely free, with no hidden limits or paid tiers. Upload files up to 2GB and share them without spending a cent.',
  },
  {
    icon: <Schedule sx={{ fontSize: 22, color: '#6C63FF' }} />,
    title: 'Gone in 24 hours',
    description: 'Every file is automatically deleted 24 hours after upload. Nothing sticks around, keeping the drive clean and your shares temporary.',
  },
];

const About = () => {
  return (
    <Box sx={{
      minHeight: '100svh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 60%, #f0eeff 100%)',
      padding: '100px 24px 80px',
      boxSizing: 'border-box',
      userSelect: 'none',
    }}>
      <Box sx={{ width: '100%', maxWidth: '760px' }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography sx={{
            fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.18em',
            color: '#aaa', textTransform: 'uppercase', mb: 1,
          }}>
            About
          </Typography>

          <Typography sx={{
            fontSize: { xs: '2.4rem', sm: '3rem' }, fontWeight: 800, letterSpacing: '-0.02em',
            color: '#6C63FF', fontFamily: 'Poppins, sans-serif', lineHeight: 1,
          }}>
            Storify
          </Typography>
        </Box>

        <Grid container spacing={2.5}>
          {features.map((feature) => (
            <Grid item xs={12} sm={6} key={feature.title}>
              <Box sx={{
                background: '#ffffff',
                borderRadius: '18px',
                boxShadow: '0 8px 32px rgba(108,99,255,0.10)',
                p: '24px 22px',
                height: '100%',
                boxSizing: 'border-box',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 40px rgba(108,99,255,0.16)',
                },
              }}>
                <Box sx={{
                  width: 42, height: 42, borderRadius: '12px',
                  background: 'rgba(108,99,255,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  mb: 1.5,
                }}>
                  {feature.icon}
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e', mb: 0.5 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#718096', lineHeight: 1.65 }}>
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{
          mt: 3,
          background: 'rgba(255, 152, 0, 0.08)',
          border: '1px solid rgba(255, 152, 0, 0.35)',
          borderRadius: '18px',
          p: '18px 22px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
        }}>
          <WarningAmber sx={{ fontSize: 22, color: '#ED6C02', mt: '2px', flexShrink: 0 }} />
          <Typography sx={{ color: '#8a4b00', fontWeight: 600, fontSize: '0.92rem', lineHeight: 1.6 }}>
            Files are public and temporary. Never upload passwords, documents with personal
            data, or anything you wouldn't hand to a stranger.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default About;